<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
 MEMBER CENTER              </p>
	</div>
   <div class="mem-full">

 <Center title='2' />

<div class="mem-con">


	<div class="login-r1">
	<div class="re-tit add-ship">
		<h4>MY COLLECTION</h4>
		
		
	</div>

	   <div class="home-arr">
		   
	   
	   	   <div class="con">
	   		   <ul>
				 
	   				   <li v-for="it in news">
						     <router-link :to="'/product/details?id='+it.inventoryId">
						  
						     <div class="skr">
								 
								   <el-tooltip class="item" effect="light" content="Select options" placement="left">
								    <img class="cart" @click.prevent="sandYart(it)" src="../../assets/cart.png" />
								    </el-tooltip>
								 <el-tooltip class="item" effect="light" content="Quick view" placement="left">
								<img class="cart" @click.prevent="finding(it)" src="../../assets/find.png" />
								  </el-tooltip>
								   <el-tooltip class="item" effect="light" content="Add to wishlist" placement="left">
								<img class="cart" @click.prevent="collect(it)" src="../../assets/like.png" />
								  </el-tooltip>
							 </div>
						
					
						   
						   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
						   <div class="pic">
							   <img :src="it.img" />
						   </div>
						   <div class="txt">
							   <p>
{{it.title}}</p>
						   <p>
{{it.remark}} </p>
 <p class="time">
$ {{it.price_sale}} </p>
 
						   </div>
	   					 </router-link>		  
	   				   </li>
				
																	
	   				 
	   			   </ul>
				 
	   	   </div>
	   </div>
	   
   <div class="page">
	     
	     <el-pagination
	       layout="prev, pager, next"
	       :total="total"
		   @current-change="pick">
	     </el-pagination>
	   </div>
	   
	    <el-dialog
	   :visible.sync="dialogVisible"
	      width="800"
	     :before-close="handleClose"
	   >
	    <div class="product-st">
	    	 
	    			   <div class="pic">
	    				  <div class="l1">
	    					
	    					 <div class="block">
	    						<img :src="proImg" />
	    					   </div>
	    				  </div>
	    			
	    			   </div>
	    			    <div class="txt">
	    					<h2>{{pro.title}}</h2>
	    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
	    					<div class="l4">
	    						$ {{pro.price_sale}}
	    						<span>Tax included</span>
	    					</div>
	    					<div class="l5">
	    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
	    						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
	    					</div>
	    					<div class="wishlist">
	    					
	    						<div class="co2">
	    							Share：
	    														<a href="https://www.facebook.com/sharer.php?u=http://localhost:8080/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
	    															
	    														<a href="http://twitter.com/share?text=FuelMe&url=http://localhost:8080/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
	    							<a href="http://service.weibo.com/share/share.php?url=http://localhost:8080/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
	    							
	    						</div>
	    					
	    					</div>
	    				</div>
	    </div>
	    </el-dialog>


	</div>

	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
 data() {
    return {
	
	
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		total:'',
		id:'',
		pro:'',
		proImg:'',
		page:1,
		channel_id:0,
		hans:'',
		channel:''
		
	
		
    
    };
  },  mounted() {
	  
 this.channel_id = this.$route.query.id;
		this.sandMate();
		this.sandHans();
		this.sandChan();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.img
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, buff(item){
				this.channel_id=item
				this.sandMate()
			},handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
						pick(item){
							this.page=item;
							this.sandMate()
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_collectList",
				  data: {page:this.page},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data.list;
						this.total=data.data.count
						
					}
				 
				});
			
			},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {is_index:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.hans=data.data;
						
						
					}
				 
				});
			
			},sandChan(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channel",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.channel=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
	.page{
		text-align: center;
		margin:50px auto;
	}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
</style>